import * as React from 'react';
import * as _ from 'lodash';
export default function () {
    return React.createElement('div', { 'className': 'tooltip' }, React.createElement('div', { 'className': 'tooltip-content' }, React.createElement('div', {
        'className': 'tooltip-content__icon',
        'aria-label': 'More info'
    }, 'i'), React.createElement('div', { 'className': 'tooltip-content__message' }, this.props.message)));
}